import * as React from 'react';
import { useBoolean } from 'ahooks';
import { InboxCustom } from '@archipro-design/icons';
import { useStyles } from '@archipro-design/aria';
import PinOverlayButton from '@modules/design-board/component/shared/PinOverlayButton';
import cx from 'classnames';
import * as S from '@modules/design-board/component/shared/TileTopActionButtons.desktop.style';
import { useCommentDialog } from '@modules/build-hub-comment/hooks/useCommentDialog';

interface CommentButtonProps {
    itemId: number;
    commentsCount?: number;
}

export function CommentButton({
                                  itemId,
                                  commentsCount,
                              }: CommentButtonProps) {
    const { css } = useStyles();
    const [tooltipState, tooltipAction] = useBoolean(false);
    const { openDialog, commentDialog } = useCommentDialog();

    const onClickComment = (e: React.SyntheticEvent<HTMLElement>) => {
        e.stopPropagation();
        e.preventDefault();
        openDialog(itemId);
    };

    // ensure strictly boolean
    const showCount = (commentsCount ?? 0) > 0;
    const displayCount =
        commentsCount && commentsCount > 9 ? "9+" : commentsCount?.toString();

    return (
        <>
            <div className="relative inline-block">
                <PinOverlayButton
                    className={cx(
                        css(S.CommentButton),
                        css(S.MessageToolTipStyle)
                    )}
                    open={tooltipState}
                    booleanActions={tooltipAction}
                    onClick={onClickComment}
                    icon={<InboxCustom />}
                    toolTipText={'Comment'}
                />
                {showCount && (
                    <span
                        className={cx(
                            "absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[8px] font-bold text-white"
                        )}
                    >
                        {displayCount}
                    </span>
                )}
            </div>
            {commentDialog()}
        </>
    );
}
